'use client';

import { useEffect, useRef, useState } from 'react';
import { DFGModal } from '@brahma/components';
import { useLogout } from '$hooks/use-logout';
import { useMutation } from '@brahma/hooks';
import { API_URLS } from '$constants/apis';
import { POST } from '@brahma/utils';
import { COMMON } from '$locale/constants';
import useLocale from '$hooks/use-locale';
import { throttle } from '@brahma/utils/throttle';
const LogoutHelper: React.FC = () => {
  const {
    t
  } = useLocale(COMMON);
  const [showModal, setShowModal] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const warningTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const {
    logout
  } = useLogout();
  const {
    mutateAsync
  } = useMutation({
    url: API_URLS.ssoLogOutUrl,
    options: {
      method: POST
    }
  });
  const handleLogout = async () => {
    await logout(() => mutateAsync({}));
    location.reload();
  };
  const startLogOutTimer = () => {
    setShowModal(true);
    timeoutRef.current = setTimeout(() => {
      handleLogout();
    }, 300000);
  };
  const resetTimers = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (warningTimeoutRef.current) {
      clearTimeout(warningTimeoutRef.current);
    }
    setShowModal(false);
    warningTimeoutRef.current = setTimeout(startLogOutTimer, 36000000);
  };
  const startInactivityTimer = () => {
    resetTimers();
  };
  const headerProps = {
    show: true,
    title: t('logout.modalTitle'),
    description: t('logout.modalDescription'),
    visibleDivider: true
  };
  const footerProps = {
    show: true,
    primaryText: t('logout.extendSessionButton'),
    primaryAction: resetTimers,
    secondaryText: t('logout.signOutButton'),
    secondaryAction: handleLogout,
    visibleDivider: false
  };
  const throttledStartInactivityTimer = throttle(startInactivityTimer, 60000);
  useEffect(() => {
    const handleUserActivity = () => {
      throttledStartInactivityTimer();
    };
    window.addEventListener('keypress', handleUserActivity);
    window.addEventListener('click', handleUserActivity);
    return () => {
      window.removeEventListener('keypress', handleUserActivity);
      window.removeEventListener('click', handleUserActivity);
      resetTimers();
    };
  }, []);
  return <>
      {showModal && <DFGModal header={headerProps} footer={footerProps} show={showModal} />}
    </>;
};
export default LogoutHelper;